var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "table-top" },
        [
          !_vm.disabled
            ? _c("el-button", { on: { click: _vm.addRow } }, [
                _vm._v("添加一行"),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vxe-table",
        {
          attrs: {
            border: "",
            align: "center",
            size: "mini",
            data: _vm.tableData,
            "edit-config": { trigger: "click", mode: "row" },
          },
        },
        [
          _c("vxe-column", {
            attrs: { align: "center", title: "序号", type: "seq", width: "60" },
          }),
          _c("vxe-column", {
            attrs: { field: "obtainNewcomerTime", title: "拉新人数" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.changeEvent },
                      model: {
                        value: row.obtainNewcomerTime,
                        callback: function ($$v) {
                          _vm.$set(row, "obtainNewcomerTime", $$v)
                        },
                        expression: "row.obtainNewcomerTime",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          _c("vxe-column", {
            attrs: { field: "integral", title: "获得积分" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-input-number", {
                      attrs: { min: 0 },
                      on: { change: _vm.changeEvent },
                      model: {
                        value: row.integral,
                        callback: function ($$v) {
                          _vm.$set(row, "integral", $$v)
                        },
                        expression: "row.integral",
                      },
                    }),
                  ]
                },
              },
            ]),
          }),
          !_vm.disabled
            ? _c("vxe-column", {
                attrs: { title: "操作", "show-overflow": "", width: "80" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function ({ row }) {
                        return [
                          _c("el-button", {
                            attrs: {
                              type: "danger",
                              icon: "el-icon-delete",
                              circle: "",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeEvent(row)
                              },
                            },
                          }),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2269260287
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }